<template>
  <TopGradientBlockLayout>
    <div class="lg:pr-50">
      <div class="text-xl font-bold text-text leading-tight mb-8">
        {{ $t('finishTitle') }}
      </div>
      <div class="text-text-label text-md leading-8 mb-12" v-html="$t('finishText')"></div>
      <div class="flex items-center space-x-4 lg:space-x-12">
        <BaseButton theme="red" @click="$router.push({name:'home'})">{{ $t('goBackBtn') }}</BaseButton>
        <WizardVideoTour/>
      </div>
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import WizardVideoTour from "@/components/cabinet/Wizard/WizardVideoTour";

export default {
  name: "WizardStep4",
  components: {WizardVideoTour, TopGradientBlockLayout, BaseButton},
  i18n: {
    messages: {
      en: {
        finishTitle: 'Congratulations! You did it!',
        finishText: `Now everything is ready to get started with MoneyKeeper.
                     <br> <br>
                     At any time, you can update your accounts, sources of income and expense categories in the settings.
                     <br> <br>
                     If you have any questions, we are always happy to help! `,
        goBackBtn: 'Go back to service',
      },
      ru: {
        finishTitle: 'Ура! У вас все получилось!',
        finishText: `Теперь все готово для начала работы в MoneyKeeper.
                    <br><br>
                    В любой момент вы можете актуализировать ваши счета, источники доходов и категории расходов в настройках.
                    <br><br>
                    Если возникнут вопросы - мы всегда рады помочь!`,
        goBackBtn: 'Перейти к работе с сервисом',
      }
    }
  }
}
</script>